function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(381 151)",
  fill: "none"
}, React.createElement("path", {
  d: "M1.3 15.98l-1 .53a.55.55 0 0 0-.3.5.58.58 0 0 0 .3.51l1 .52a8.81 8.81 0 0 0 4.09 1h17.87a12.48 12.48 0 0 0 3.54-.52L31.32 17l-4.52-1.52a12.48 12.48 0 0 0-3.54-.52H5.39a8.81 8.81 0 0 0-4.09 1.02z",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M2.92 15.96l-.13.07a1.16 1.16 0 0 0-.52.91v.14c.019.369.212.707.52.91l.13.07c.16.085.339.13.52.13a.05.05 0 0 0 0-.1 1.16 1.16 0 0 1-.34-.24l-.1-.1a1.23 1.23 0 0 1-.26-.67v-.14a1.17 1.17 0 0 1 .26-.66.52.52 0 0 1 .1-.11 1 1 0 0 1 .34-.23c.05 0 0-.11 0-.11-.181 0-.36.045-.52.13",
  fill: "#46C3D7"
}), React.createElement("path", {
  d: "M14.25 23.24v-.59a.63.63 0 0 0-.61-.63l-2.14-.15h-.32v.28a6.83 6.83 0 0 0 0 1.65v.28l1.69-.12.77-.06a.63.63 0 0 0 .61-.66z",
  fill: "#145569"
}), React.createElement("path", {
  d: "M11.09 22.93a7.55 7.55 0 0 1 .05-.83v-.28h-.27a.18.18 0 0 0-.18.16v.12a5.7 5.7 0 0 0 0 1.65v.12a.18.18 0 0 0 .18.16h.27v-.28a7.52 7.52 0 0 1-.05-.82zm5.04 3.05l-2-.14h-.76a.19.19 0 0 0-.18.16v.12a5.7 5.7 0 0 0 0 1.65v.12a.19.19 0 0 0 .18.16h.33l1.83-.13.62-.05a.63.63 0 0 0 .62-.63v-.59a.63.63 0 0 0-.64-.67zm-2.49 1.75a5.7 5.7 0 0 1 0-1.65v-.16.16a5.7 5.7 0 0 0 0 1.65v.18-.18zm.06-17.58l-.77-.05-1.69-.12h-.28a.17.17 0 0 0-.17.15v.13a5.66 5.66 0 0 0 0 1.65v.12a.16.16 0 0 0 .17.15H11.56l2.14-.15a.63.63 0 0 0 .61-.64v-.58a.65.65 0 0 0-.61-.66zm-2.5 1.76a5.79 5.79 0 0 1 0-1.65v-.12.12a5.66 5.66 0 0 0 0 1.65v.13-.13zm4.95-5.74h-.62l-1.83-.13v.28a5.66 5.66 0 0 0 0 1.65v.27-.27a5.79 5.79 0 0 1-.06-.83 5.66 5.66 0 0 1 .06-.9v-.28h-.28a.18.18 0 0 0-.18.15v.13a5.66 5.66 0 0 0 0 1.65v.12a.18.18 0 0 0 .18.16h.75l2-.14a.63.63 0 0 0 .61-.64v-.58a.65.65 0 0 0-.63-.64z",
  fill: "#145569"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M21.7200924 34L17.6600924 20.99 17.0600924 19.05 9.99009241 19.05 11.2900924 20.99 19.5300924 33.38z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M19.5300924 33.38L9.99009241 19.05 10.8400924 19.05 20.5700924 33.67z"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M21.7400924 2.84217094e-14L17.6800924 13.01 17.0700924 14.96 10.0100924 14.96 11.3000924 13.01 19.5500924 0.63z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M19.5400924 0.63L10.0100924 14.96 10.8600924 14.96 20.5900924 0.33z"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M33.0400924 10.95L31.4000924 14.98 30.6700924 16.76 26.9300924 16.67 28.3900924 14.98 31.7800924 11.07z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M31.7800924 11.07L26.9300924 16.67 27.6000924 16.67 32.5100924 11z"
}), React.createElement("path", {
  fill: "#B93296",
  d: "M33.0400924 23.09L31.4000924 19.06 30.6700924 17.26 26.9300924 17.37 28.3900924 19.06 31.7800924 22.96z"
}), React.createElement("path", {
  fill: "#DFABD1",
  d: "M31.7800924 22.96L26.9300924 17.37 27.6000924 17.37 32.5100924 23.04z"
}), React.createElement("path", {
  d: "M25.4 17.01a.38.38 0 0 0 .39.38l7.32-.19a.19.19 0 0 0 0-.38l-7.32-.19a.38.38 0 0 0-.39.38z",
  fill: "#DFABD1"
}));

var SvgPlaneNorth = function SvgPlaneNorth(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 415 401",
    width: 415,
    height: 401,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlaneNorth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/planeNorth.628e5a0b.svg";
export { ForwardRef as ReactComponent };